import { useVODService } from '@/app/context/DIContext/DIServices'
import {
    homeInitialRowIndex,
    homeRowId,
    homeRowsCount,
} from '@/shared/constants'
import { getErrorMessage } from '@/shared/lib'
import { useAppStore } from '@/shared/store'
import { VodRowViewProps } from '@/types/vod/vodRow'
import { useEffect, useState } from 'react'

const useHomeContent = () => {
    const [homeRows, setHomeRows] = useState<VodRowViewProps[]>()
    const { getRows } = useVODService()

    const actualProfile = useAppStore((state) => state.actualProfile)

    const getHomeContent = async () => {
        try {
            const response = await getRows(
                homeRowId,
                homeInitialRowIndex,
                homeRowsCount
            )

            if (response) setHomeRows(response)
        } catch (error) {
            getErrorMessage('fetchVodRows', error)
        }
    }

    useEffect(() => {
        setHomeRows([])
        getHomeContent()
    }, [actualProfile])
    return { homeRows, setHomeRows }
}

export default useHomeContent
